import React from 'react';

export const requiredCustomLanguageStack = [
  {
    name: 'languageName',
    label: 'Language Name',
    placeholder: 'Custom Language Name',
    required: true,
    validationRules: {
      required: { value: true, message: 'Custom Language Name is a required field' },
      minLength: { value: 3, message: 'Custom Language must have at least three characters' },
      maxLength: { value: 190, message: 'Custom Language Name must have fewer than 190 characters' }
    }
  },
  {
    name: 'language',
    label: 'Language',
    placeholder: 'Type your language requirements here...',
    type: 'textArea',
    validationRules: {}
  }
];
